import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import 'dayjs/locale/it';
import {
  getCookie,
  setCookie,
} from 'packages/blu-booking/src/utility_objects/CookieManager';
import {
  removePointOfSale,
  removeService,
  removeStudio,
  selectPointOfSale,
  selectService,
  selectStudio,
  selectZoomValue,
  setUser,
  setSelectedDate,
  setClient,
} from '../../../utility_objects/StoreFunctions';
import {
  getSoloOrarioSalvato,
  salvaSoloOrario,
} from '../../../utility_objects/preferenzeCalendario';
import { UserSelectedFiltersState } from './interface';

const initialState: UserSelectedFiltersState = {
  view: getCookie('userCalendarView') || 'Day',
  selectedDate: new Date(),
  selectedServices: [],
  selectedStudi: [],
  selectedUsers: [],
  zoom: {
    value: 150,
    interval: 60,
    slotCount: 4,
  },
  zoomValue: 150,
  // Riga Ore del riquadro Visualizzazione di questo calendario, ricordata per
  // PC per un anno nel cookie userCalendarSoloOrario: «Tutte» di default.
  soloOrario: getSoloOrarioSalvato('utente'),
};

const UserCalendarSlice = createSlice({
  name: 'BluBookingUserCalendar',
  initialState,
  reducers: {
    UserCalendarSetView: (
      state: UserSelectedFiltersState,
      action: PayloadAction<'Day' | 'TimelineDay'>
    ) => {
      state.view = action.payload;
      setCookie('userCalendarView', action.payload);
    },
    UserCalendarSetSoloOrario(
      state: UserSelectedFiltersState,
      action: PayloadAction<boolean>
    ) {
      state.soloOrario = action.payload;
      salvaSoloOrario('utente', action.payload);
    },

    UserCalendarSetSelectedDate: setSelectedDate,
    UserCalendarSelectZoomValue: selectZoomValue,
    // ? ADD
    UserCalendarSelectPointOfSale: selectPointOfSale,
    UserCalendarSetService: selectService,
    UserCalendarSelectStudio: selectStudio,
    UserCalendarSetUser: setUser,
    UserCalendarSetClient: setClient,
    // ? REMOVE
    UserCalendarRemoveStudio: removeStudio,
    UserCalendarRemoveService: removeService,
    UserCalendarRemovePointOfSale: removePointOfSale,

    UserCalendarResetSelected: (
      state: UserSelectedFiltersState,
      action: PayloadAction<string>
    ) => {
      return { ...state, [action.payload]: [] };
    },
    UserCalendarReset: () => initialState,
  },
});

export const {
  UserCalendarSetSelectedDate,
  UserCalendarSelectZoomValue,
  UserCalendarSelectPointOfSale,
  UserCalendarSetService,
  UserCalendarSelectStudio,
  UserCalendarRemoveStudio,
  UserCalendarRemoveService,
  UserCalendarRemovePointOfSale,
  UserCalendarResetSelected,
  UserCalendarSetUser,
  UserCalendarSetClient,
  UserCalendarReset,
  UserCalendarSetView,
  UserCalendarSetSoloOrario,
} = UserCalendarSlice.actions;

export default UserCalendarSlice.reducer;
